import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getProfileImage } from '../redux/actions/imgAction';


const Card = ({user}) => {
  const dispatch = useDispatch();
  const { imageData, loading } = useSelector((state) => state.img);
  useEffect(() => {
    if (user.id) {
      dispatch(getProfileImage(user.id));
    }
    }, [dispatch, user.id]);

    const getImageSrc = () => {
      if (imageData[user.id]?.data?.length > 0 && imageData[user.id].data[0].content) {
        return `data:image/jpeg;base64,${imageData[user.id].data[0].content}`;
      }
      return "/defaultPerson.svg";
    };
    return (
      <div className='flex gap-4 items-center p-4 shadow-cardShadow hover:shadow-hoverShadow rounded-2xl min-w-[280px] max-w-[320px] w-full'>
        <div className="relative w-[64px] h-[64px]">
          {loading ? (
            <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded-full">
              <span className="text-gray-500"></span>
            </div>
          ) : (
            <img
              src={getImageSrc()}
              alt="person"
              className="w-full h-full object-cover rounded-full border-2 border-gray-300"
            />
          )}
        </div>
        <div className='flex flex-col gap-2'>
          <p className='text-dark text-lg'>{user?.name}</p>
          <p className='text-sm text-grayy'>{user?.position?.name}</p>
        </div>
      </div>
    );
  }
export default Card